import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  element: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  circle: {
    border: '1px solid #3C4858',
    borderRadius: '50%',
  },
  circleBig: {
    width: '60px',
    height: '60px',
  },
  circleSmall: {
    width: '50px',
    height: '50px',
  },
  number: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    textAlign: 'left',
    fontSize: '10px',
  },
});

const Quantity = ({ number, size }) => {
  const classes = useStyles();
  let circleSize;
  if (size === 'small') circleSize = classes.circleSmall;
  else if (size === 'big') circleSize = classes.circleBig;

  return (
    <div className={classes.element}>
      <p className={`${classes.circle} ${circleSize}`}>
        <span className={classes.number}>{number}</span>
      </p>
      <p className={classes.label}>Кількість ТГ</p>
    </div>
  );
};

export default Quantity;
